export default "__VITE_ASSET__oonuQvn6__"